import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { PageTitle } from '../../../components/common/PageTitle/PageTitle';
import * as S from '../Legal.styles';

const href = window.location.href;
const noIndex = true;

// Legal page links data
const legalLinks = [
  {
    path: '/legal/tos/',
    title: 'Terms of Service',
    description: 'By accessing, browsing, and/or using any of our websites, you acknowledge that you have read, understood, and agree to be bound by these terms.'
  },
  {
    path: '/legal/security/',
    title: 'Security Practices',
    description: 'OMR Quiz takes security very seriously. Learn what steps we take to ensure your data is secure.'
  },
  {
    path: '/legal/file-retention-policy/',
    title: 'File Retention Policy',
    description: 'Details about we how we treat retention of those files for both non account and account users.'
  },
  {
    path: '/legal/acceptable-use/',
    title: 'Acceptable Use Policy',
    description: 'Use of the OMR Quiz API is subject to this acceptable use policy.'
  },
  {
    path: '/legal/subprocessors/',
    title: 'Subprocessors',
    description: 'This page provides important information about the identity, location and role of each Subprocessor OMR Quiz uses.'
  },
  {
    path: '/legal/copyright-notice/',
    title: 'Copyright Notice',
    description: 'The complete copyright notice detailing the rights of OMR Quiz with regards to the contents of the website.'
  },
  {
    path: '/legal/privacy-policy/',
    title: 'Privacy Policy',
    description: 'A detailed description of the OMR Quiz privacy policy with regards to the users of the OMR Quiz website.'
  },
  {
    path: '/legal/gdpr/',
    title: 'GDPR Public Policy',
    description: 'Review our dedicated page to learn more about our approach to GDPR.'
  },
  {
    path: '/legal/dmca-policy/',
    title: 'DMCA Policy',
    description: 'Our policy surrounding copyrighted works or materials improperly accessible on our website (DMCA).'
  },
  {
    path: '/legal/paperless-policy/',
    title: 'Paperless Policy',
    description: 'OMR Quiz is a 100% electronic company and does not accept any physical documents.'
  }
];

const LegalPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle 
        title={t('head:aboutUsTitle')} 
        description={t('head:aboutUsDescription')} 
        url={href} 
        noIndex={noIndex} 
      />
      
      <S.H1 level={1}>Legal</S.H1>
      <S.Paragraph>
        In this section you can find detailed legal information regarding various terms and policies for OMR Quiz App.
      </S.Paragraph>

      <S.Section>
        {legalLinks.map((link, index) => (
          <Link to={link.path} key={index} style={{ textDecoration: 'none' }}>
            <S.LinkCard>
              <h4>{link.title}</h4>
              <p>{link.description}</p>
            </S.LinkCard>
          </Link>
        ))}
      </S.Section>
    </>
  );
};

export default LegalPage;